/**
 * hex 色值转 rgba（用于渐变透明度控制）
 */
function hexToRgba(hex, alpha = 1) {
	const c = String(hex || '').replace('#', '');
	if (c.length !== 6) return `rgba(0,0,0,${alpha})`;
	const r = parseInt(c.substring(0, 2), 16);
	const g = parseInt(c.substring(2, 4), 16);
	const b = parseInt(c.substring(4, 6), 16);
	return `rgba(${r},${g},${b},${alpha})`;
}

export function formatPayPrice(value) {
	const num = Number.parseFloat(String(value ?? '').replace(/[^\d.-]/g, ''));
	if (Number.isNaN(num)) return '0.00';
	return num.toFixed(2);
}

export function formatPayCount(value, fallback = 0) {
	const count = Number.parseInt(String(value ?? ''), 10);
	return Number.isNaN(count) ? fallback : count;
}

export function formatCurrencyPrice(data, fallback = '0.00') {
	const currency = data?.currency || '¥';
	const price = formatPayPrice(data?.price ?? fallback);
	return currency === '¥' ? `¥ ${price}` : `${currency}${price}`;
}

/**
 * 获取按钮渐变样式（起始色 85% 透明度 → 结束色原色）
 */
export function getButtonStyle(data, defaults = {}) {
	const color = data?.buttonColor || defaults.buttonColor || '#ff4b2b';
	return {
		background: `linear-gradient(180deg, ${hexToRgba(color, 0.85)}, ${color})`,
	};
}

/**
 * 获取 buttonColor（图标/价格共用此色）
 */
export function getButtonColor(data, defaults = {}) {
	return data?.buttonColor || defaults.buttonColor || '#ff4b2b';
}
